import { createFeature, createReducer, on } from '@ngrx/store';

import { PacketReference } from '@core/models';
import { PacketApiActions, PacketPageActions } from './packet.actions';

/**
 * `packet` feature slice — the read-only packet reference data plus load flags.
 * `reference` is null until the first successful load. A plain load lifecycle;
 * nothing here is mutated by the UI.
 */
export interface PacketState {
  /** Loaded packet reference, or null before the first load. */
  readonly reference: PacketReference | null;
  readonly loading: boolean;
  readonly error: string | null;
}

const initialState: PacketState = {
  reference: null,
  loading: false,
  error: null,
};

export const packetFeature = createFeature({
  name: 'packet',
  reducer: createReducer(
    initialState,
    // Page entered: begin loading, clear any prior error.
    on(PacketPageActions.entered, (state) => ({ ...state, loading: true, error: null })),
    // Load resolved: store the reference and stop loading.
    on(PacketApiActions.loadSuccess, (state, { reference }) => ({
      ...state,
      reference,
      loading: false,
    })),
    // Load rejected: stop loading and record the error message.
    on(PacketApiActions.loadFailure, (state, { error }) => ({ ...state, loading: false, error })),
  ),
});

export const { selectReference, selectLoading, selectError } = packetFeature;
